import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AdditionalDataItemDispatcher } from "./Variable";

export interface AdditionalDataItemStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class AdditionalDataItemStatic extends BaseStore<AdditionalDataItemStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AdditionalDataItemDispatcher, (actionData) =>
            this.onClientRecordStoreResponse(actionData)
        );
    }

    public getLastResult(): AdditionalDataItemStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AdditionalDataItemStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onClientRecordStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
